var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "load-progress-bar", class: _vm.colorClass },
    [
      _c("div", { staticClass: "progress-container" }, [
        _c("div", { staticClass: "progress-midline" }),
        _vm._v(" "),
        _c("div", {
          staticClass: "progress-fill",
          style: { width: _vm.fillWidth + "%" },
        }),
      ]),
      _vm._v(" "),
      _vm.showPercent
        ? _c("span", { staticClass: "percent-label" }, [
            _vm._v("\n        " + _vm._s(Math.round(_vm.percent)) + "%\n    "),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }